import { useEffect, useRef, useState } from 'react';
import { confirm } from '../utils/confirm';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../components/Toast';
import { useModal } from '../components/ModalProvider';
import Avatar from '../components/Avatar';
import Modal from '../components/Modal';
import { fmtDate } from '../utils/format';
import { listCskhLogs, createCskhLog, removeCskhLog, getCskhWeekReport, saveCskhWeekReport, addCskhUpdate, resolveCskhLog } from '../api/cskhLogs';
import { searchCustomers } from '../api/customers';
import { listGroups } from '../api/groups';
import { createTask } from '../api/tasks';
import CreateTaskFromCustomers from '../components/CreateTaskFromCustomers';

const RESULTS = {
  happy: { label: 'KH hài lòng', color: '#16a34a' },
  noanswer: { label: 'KH ko nghe máy', color: '#d9a400' },
  unhappy: { label: 'KH không hài lòng', color: '#dc2626' },
  stopped: { label: 'KH dừng giảm', color: '#9333ea' },
  resolved: { label: 'Đã xử lí', color: '#0d9488' },
};
const today = () => new Date().toISOString().slice(0, 10);
const monthAgo = () => new Date(Date.now() - 29 * 864e5).toISOString().slice(0, 10);
const ymd = (dt) => `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, '0')}-${String(dt.getDate()).padStart(2, '0')}`;

export default function CskhLogTab() {
  const { me } = useAuth();
  const toast = useToast();
  const { openModal, closeModal } = useModal();
  const myId = String(me.id || me._id);
  const isAdmin = me.role === 'GD' || me.role === 'CV';
  const canReport = isAdmin || (me.deptHeadOf || []).includes('Phòng CSKH'); // chỉ TP CSKH nộp báo cáo tuần
  const canLog = isAdmin || (me.departments || []).includes('Phòng CSKH'); // chỉ Phòng CSKH ghi nhật ký; sale chỉ xem KH mình

  const [from, setFrom] = useState(monthAgo());
  const [to, setTo] = useState(today());
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [denied, setDenied] = useState(false);
  const scroller = useRef(null); // timeline cuộn ngang

  // form thêm
  const [date, setDate] = useState(today());
  const [type, setType] = useState('cskh');
  const [content, setContent] = useState('');
  const [result, setResult] = useState('');
  // chọn KH (typeahead)
  const [custQ, setCustQ] = useState('');
  const [custId, setCustId] = useState(null);
  const [custCode, setCustCode] = useState('');
  const [custName, setCustName] = useState('');
  const [custSale, setCustSale] = useState('');
  const [custSug, setCustSug] = useState([]);
  const [custOpen, setCustOpen] = useState(false);
  const [detail, setDetail] = useState(null); // { title, keys:Set, kind }
  const [weekReport, setWeekReport] = useState(null); // { from, to, label }
  // Lọc bảng "Chi tiết" theo LOẠI công việc + KẾT QUẢ.
  const [fType, setFType] = useState('all');   // all | cskh | xlkn
  const [fResult, setFResult] = useState('all'); // all | happy | noanswer | unhappy | stopped | resolved
  const [onlyPending, setOnlyPending] = useState(false); // chỉ việc CHƯA xử lí xong (XLKN/không hài lòng, chưa ấn Hoàn thành)

  useEffect(() => {
    if (!custQ.trim() || custId) {
      setCustSug([]);
      return;
    }
    const t = setTimeout(() => searchCustomers(custQ.trim()).then(setCustSug).catch(() => {}), 250);
    return () => clearTimeout(t);
  }, [custQ, custId]);

  function pickCust(c) {
    setCustId(c.id);
    setCustCode(c.code);
    setCustName(c.name);
    setCustSale(c.sale || '');
    setCustQ(`${c.code} · ${c.name}`);
    setCustOpen(false);
  }
  function clearCust() {
    setCustId(null);
    setCustCode('');
    setCustName('');
    setCustSale('');
    setCustQ('');
  }

  function reload() {
    setLoading(true);
    listCskhLogs({ from, to })
      .then((d) => {
        setLogs(d);
        setDenied(false);
      })
      .catch((err) => {
        if (err.response?.status === 403) setDenied(true);
      })
      .finally(() => setLoading(false));
  }
  useEffect(reload, [from, to]);
  // Cuộn timeline về cuối (ngày mới nhất) mỗi khi dữ liệu đổi.
  useEffect(() => { if (scroller.current) scroller.current.scrollLeft = scroller.current.scrollWidth; }, [logs]);

  async function add() {
    if (!content.trim()) return;
    try {
      await createCskhLog({ date, type, content: content.trim(), customer: custQ.trim(), custId, custCode, custName, custSale, result });
      setContent('');
      setResult('');
      clearCust();
      toast('Đã thêm công việc');
      reload();
    } catch (err) {
      toast(err.response?.data?.message || 'Có lỗi', 'danger');
    }
  }
  async function del(id) {
    if (!await confirm('Xóa công việc này?')) return;
    await removeCskhLog(id);
    reload();
  }

  // CSKH BỔ SUNG NỘI DUNG cho 1 việc đã ghi (mở ô nhập nhiều dòng).
  function doAddUpdate(log) {
    openModal(
      <UpdateStatusModal log={log} onCancel={closeModal}
        onSubmit={async (text) => {
          try { await addCskhUpdate(log._id, text); closeModal(); toast('Đã cập nhật tình trạng'); reload(); }
          catch (e) { toast(e.response?.data?.message || 'Có lỗi xảy ra', 'danger'); }
        }} />
    );
  }
  // XÁC NHẬN đã xử lí xong (XLKN / KH không hài lòng) — hoặc bỏ đánh dấu.
  async function doResolve(log, done) {
    if (done && !await confirm('Xác nhận việc này ĐÃ XỬ LÍ XONG?')) return;
    try {
      await resolveCskhLog(log._id, done);
      toast(done ? 'Đã đánh dấu hoàn thành' : 'Đã bỏ đánh dấu hoàn thành');
      reload();
    } catch (e) { toast(e.response?.data?.message || 'Có lỗi xảy ra', 'danger'); }
  }

  // Từ 1 dòng nhật ký CSKH -> tạo công việc cho KH đó. Backend tự giao về NHÓM của sale KH này
  // (trạng thái chờ TP xác nhận) -> TP giao lại cho sale -> sale phản hồi -> TP duyệt.
  async function openTaskFor(cCode, cName) {
    if (!cCode) return toast('Công việc này chưa gắn mã KH', 'warn');
    let groups = [];
    try { groups = await listGroups(); } catch { /* GĐ/CSKH vẫn tạo được với nhóm "tất cả" */ }
    openModal(
      <CreateTaskFromCustomers
        picked={[{ code: cCode, name: cName || cCode }]}
        groups={groups}
        onCancel={closeModal}
        onSubmit={async (form) => {
          try {
            const res = await createTask({ ...form, custCodes: [cCode] });
            closeModal();
            toast(res?.message || 'Đã tạo & giao công việc');
          } catch (err) {
            toast(err.response?.data?.message || 'Có lỗi xảy ra', 'danger');
          }
        }}
      />
    );
  }

  if (denied) {
    return (
      <div className="card">
        <div className="empty" style={{ padding: 40, textAlign: 'center' }}>
          🔒 Chỉ <b>Phòng CSKH</b> và <b>Giám đốc</b> dùng được mục này.
        </div>
      </div>
    );
  }

  // Đếm CSKH / XLKN theo ngày
  const emptyStat = () => ({ cskh: 0, xlkn: 0, happy: 0, unhappy: 0, noanswer: 0, stopped: 0, resolved: 0 });
  const dayMap = {};
  logs.forEach((l) => {
    const k = ymd(new Date(l.date));
    const m = dayMap[k] || (dayMap[k] = emptyStat());
    if (l.type === 'xlkn') m.xlkn++;
    else {
      m.cskh++;
      if (l.result && m[l.result] !== undefined) m[l.result]++;
    }
  });

  // Tổng kết 7 ngày tính lùi từ 1 ngày (thứ 5) — dùng cho thẻ "Tổng tuần".
  const weekSum = (thu) => {
    const s = emptyStat();
    for (let i = 0; i < 7; i++) {
      const dd = new Date(thu);
      dd.setDate(dd.getDate() - i);
      const m = dayMap[ymd(dd)];
      if (m) ['cskh', 'xlkn', 'happy', 'unhappy', 'noanswer', 'stopped', 'resolved'].forEach((kk) => (s[kk] += m[kk]));
    }
    return s;
  };

  // Thứ 5 của tuần chứa ngày "đến" — mốc gom tổng tuần.
  const todayD = new Date(to + 'T00:00:00');
  const thu = new Date(todayD);
  thu.setDate(todayD.getDate() + ((4 - todayD.getDay() + 7) % 7));

  // Mở danh sách chi tiết KH theo ô số đã bấm.
  const openDetail = (keys, kind, title) => setDetail({ keys: new Set(keys), kind, title });
  const matchKind = (l, kind) => {
    if (kind === 'cskh') return l.type === 'cskh';
    if (kind === 'xlkn') return l.type === 'xlkn';
    return l.type === 'cskh' && l.result === kind; // happy / noanswer / unhappy
  };
  const detailRows = detail ? logs.filter((l) => detail.keys.has(ymd(new Date(l.date))) && matchKind(l, detail.kind)) : [];

  // "Chưa xử lí xong" = việc CÓ nút Hoàn thành (XLKN hoặc KH không hài lòng) nhưng CSKH CHƯA ấn (resolvedAt rỗng).
  const isPending = (l) => (l.type === 'xlkn' || l.result === 'unhappy') && !l.resolvedAt;
  const pendingCount = logs.filter(isPending).length;
  // gom theo ngày cho danh sách chi tiết — sau khi LỌC theo loại + kết quả + (tuỳ chọn) chưa xử lí xong.
  const detailLogs = logs.filter((l) => {
    if (onlyPending && !isPending(l)) return false;
    if (fType !== 'all' && l.type !== fType) return false;
    if (fResult !== 'all' && l.result !== fResult) return false;
    return true;
  });
  const byDay = {};
  detailLogs.forEach((l) => {
    const k = fmtDate(l.date);
    (byDay[k] = byDay[k] || []).push(l);
  });

  // Tổng tuần hiện tại (tuần chứa ngày "đến") cho thẻ tóm tắt bên phải (thiết kế mới).
  const cw = weekSum(thu);
  const cwTotal = cw.cskh + cw.xlkn;
  const cwKeys = (() => { const a = []; for (let i = 0; i < 7; i++) { const dd = new Date(thu); dd.setDate(dd.getDate() - i); a.push(ymd(dd)); } return a; })();
  const cwLabel = `đến ${thu.getDate()}/${thu.getMonth() + 1}`;

  // Timeline cuộn ngang: mỗi ô = 1 ngày; sau mỗi thứ 5 chèn ô "tổng tuần". Thêm ô tuần hiện tại ở cuối.
  const WD = ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'];
  const cells = [];
  {
    const start = new Date(from + 'T00:00:00');
    const end = new Date(to + 'T00:00:00');
    for (let d = new Date(start); d <= end; d.setDate(d.getDate() + 1)) {
      const k = ymd(d);
      const m = dayMap[k] || emptyStat();
      cells.push({ type: 'day', key: k, keys: [k], dow: d.getDay(), day: d.getDate(), month: d.getMonth() + 1, ...m });
      if (d.getDay() === 4) {
        const wk = []; for (let i = 0; i < 7; i++) { const dd = new Date(d); dd.setDate(dd.getDate() - i); wk.push(ymd(dd)); }
        cells.push({ type: 'week', key: 'w' + k, keys: wk, day: d.getDate(), month: d.getMonth() + 1, ...weekSum(d) });
      }
    }
    const thuKey = ymd(thu);
    if (!cells.some((c) => c.type === 'week' && c.key === 'w' + thuKey)) {
      cells.push({ type: 'week', key: 'w' + thuKey, keys: cwKeys, day: thu.getDate(), month: thu.getMonth() + 1, current: true, ...cw });
    }
  }

  return (
    <>
      {/* Timeline công việc CSKH theo ngày (cuộn ngang) — như thiết kế cũ */}
      <div className="card" style={{ marginBottom: 16 }}>
        <div className="row between" style={{ marginBottom: 12, flexWrap: 'wrap', gap: 8 }}>
          <h3 style={{ margin: 0 }}>📋 Công việc CSKH theo ngày</h3>
          <div className="row" style={{ gap: 8, alignItems: 'center' }}>
            <input type="date" value={from} onChange={(e) => setFrom(e.target.value)} style={{ width: 'auto' }} />
            <span>→</span>
            <input type="date" value={to} onChange={(e) => setTo(e.target.value)} style={{ width: 'auto' }} />
          </div>
        </div>
        {loading ? (
          <div className="empty">Đang tải…</div>
        ) : (
          <div className="tl-wrap">
            <button className="tl-arrow" onClick={() => scroller.current?.scrollBy({ left: -600, behavior: 'smooth' })}>‹</button>
            <div className="tl-scroll" ref={scroller}>
              {cells.map((c) => {
                const head = c.type === 'day'
                  ? `${WD[c.dow]} · ${c.day}/${c.month}`
                  : `📊 ${c.current ? 'Tổng tuần này' : 'Tổng tuần'} (đến ${c.day}/${c.month})`;
                return (
                  <div key={c.key} className={'cslog-cell' + (c.type === 'week' ? ' week' : c.dow === 4 ? ' thu' : '')}>
                    <div className="cslog-head">{head}</div>
                    <div className="cslog-row">
                      <span>👥 CSKH</span>
                      <b className="cslog-click" onClick={() => c.cskh > 0 && openDetail(c.keys, 'cskh', `Chăm sóc KH · ${head}`)}>{c.cskh || 0}</b>
                    </div>
                    {c.cskh > 0 && (
                      <div className="cslog-sub">
                        <span className="cslog-click" style={{ color: RESULTS.happy.color }} onClick={() => c.happy > 0 && openDetail(c.keys, 'happy', `KH hài lòng · ${head}`)}>● {c.happy}</span>
                        <span className="cslog-click" style={{ color: RESULTS.noanswer.color }} onClick={() => c.noanswer > 0 && openDetail(c.keys, 'noanswer', `KH không nghe máy · ${head}`)}>● {c.noanswer}</span>
                        <span className="cslog-click" style={{ color: RESULTS.unhappy.color }} onClick={() => c.unhappy > 0 && openDetail(c.keys, 'unhappy', `KH không hài lòng · ${head}`)}>● {c.unhappy}</span>
                        <span className="cslog-click" style={{ color: RESULTS.stopped.color }} onClick={() => c.stopped > 0 && openDetail(c.keys, 'stopped', `KH dừng giảm · ${head}`)}>● {c.stopped}</span>
                        <span className="cslog-click" style={{ color: RESULTS.resolved.color }} onClick={() => c.resolved > 0 && openDetail(c.keys, 'resolved', `Đã xử lí · ${head}`)}>● {c.resolved}</span>
                      </div>
                    )}
                    <div className="cslog-row">
                      <span>⚠️ XLKN</span>
                      <b className="cslog-click" onClick={() => c.xlkn > 0 && openDetail(c.keys, 'xlkn', `Xử lý khiếu nại · ${head}`)}>{c.xlkn || 0}</b>
                    </div>
                    {c.type === 'week' && <div className="cslog-row tot"><span>Tổng việc</span><b>{c.cskh + c.xlkn}</b></div>}
                    {c.type === 'week' && canReport && (
                      <button className="btn sm" style={{ width: '100%', marginTop: 8 }}
                        onClick={() => { const ks = [...c.keys].sort(); setWeekReport({ from: ks[0], to: ks[ks.length - 1], label: `Tuần (đến ${c.day}/${c.month})` }); }}>
                        📝 Báo cáo tuần
                      </button>
                    )}
                  </div>
                );
              })}
            </div>
            <button className="tl-arrow" onClick={() => scroller.current?.scrollBy({ left: 600, behavior: 'smooth' })}>›</button>
          </div>
        )}
      </div>

      {loading ? (
        <div className="card"><div className="empty">Đang tải…</div></div>
      ) : (
      <div className="grid" style={{ gridTemplateColumns: canLog ? 'minmax(0,1.15fr) minmax(0,1fr)' : '1fr', gap: 16, marginBottom: 16, alignItems: 'start' }}>
        {canLog && (
          <div className="card" style={{ margin: 0 }}>
            <h3 style={{ marginTop: 0 }}>＋ Ghi công việc CSKH</h3>
            <div className="two-col">
              <div className="field">
                <label>Ngày</label>
                <input type="date" value={date} onChange={(e) => setDate(e.target.value)} onClick={(e) => e.currentTarget.showPicker?.()} />
              </div>
              <div className="field">
                <label>Loại công việc</label>
                <select value={type} onChange={(e) => setType(e.target.value)}>
                  <option value="cskh">Chăm sóc KH (CSKH)</option>
                  <option value="xlkn">Xử lý khiếu nại (XLKN)</option>
                </select>
              </div>
            </div>
            <div className="two-col">
              <div className="field" style={{ position: 'relative' }}>
                <label>Khách hàng (tìm theo mã / tên)</label>
                <input
                  value={custQ}
                  onChange={(e) => {
                    setCustQ(e.target.value);
                    setCustId(null);
                    setCustCode('');
                    setCustOpen(true);
                  }}
                  onFocus={() => setCustOpen(true)}
                  placeholder="Gõ mã KH hoặc tên KH…"
                />
                {custId && <span className="cs-cust-ok">✓ đã chọn</span>}
                {custOpen && custSug.length > 0 && !custId && (
                  <div className="cs-cust-pop">
                    {custSug.map((c) => (
                      <div key={c.id} className="cs-cust-item" onClick={() => pickCust(c)}>
                        <b>{c.code}</b> · {c.name}
                        {c.sale ? <span className="small muted"> — {c.sale}</span> : null}
                      </div>
                    ))}
                  </div>
                )}
              </div>
              <div className="field">
                <label>Kết quả</label>
                <select value={result} onChange={(e) => setResult(e.target.value)}>
                  <option value="">— Chọn kết quả —</option>
                  {Object.entries(RESULTS).map(([k, v]) => (
                    <option key={k} value={k}>
                      {v.label}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="field">
              <label>Nội dung công việc</label>
              <textarea value={content} onChange={(e) => setContent(e.target.value)} placeholder={"vd: Gọi chăm sóc KH sau mua…\n(Enter để xuống dòng cho dễ trình bày)"} rows={4} style={{ resize: 'vertical', minHeight: 92 }} />
            </div>
            <div className="row">
              <div className="spacer" />
              <button className="btn" disabled={!content.trim()} onClick={add}>
                Thêm công việc
              </button>
            </div>
          </div>
        )}

        {/* Tổng tuần (tuần chứa ngày "đến") */}
        <div className="card" style={{ margin: 0 }}>
          <h3 style={{ marginTop: 0 }}>Tổng tuần ({cwLabel})</h3>
          <div className="row" style={{ gap: 22, alignItems: 'baseline', flexWrap: 'wrap' }}>
            <div>
              <div className="mono" style={{ fontSize: 30, fontWeight: 700, lineHeight: 1 }}>{cwTotal}</div>
              <div className="small muted">Tổng việc</div>
            </div>
            <div className="row" style={{ gap: 20, alignItems: 'baseline', flexWrap: 'wrap' }}>
              {[['happy', 'Hài lòng', cw.happy], ['noanswer', 'Không nghe', cw.noanswer], ['unhappy', 'Không hài lòng', cw.unhappy], ['stopped', 'Dừng giảm', cw.stopped], ['resolved', 'Đã xử lí', cw.resolved]].map(([k, lbl, n]) => (
                <div key={k} className="cslog-click" onClick={() => n > 0 && openDetail(cwKeys, k, `${RESULTS[k].label} · Tổng tuần (${cwLabel})`)}>
                  <span className="mono" style={{ fontSize: 22, fontWeight: 700, color: RESULTS[k].color }}>{n}</span>{' '}
                  <span className="small muted">{lbl}</span>
                </div>
              ))}
            </div>
          </div>
          {cw.xlkn > 0 && (
            <div
              className="cslog-click"
              onClick={() => openDetail(cwKeys, 'xlkn', `Xử lý khiếu nại · Tổng tuần (${cwLabel})`)}
              style={{ marginTop: 16, background: 'color-mix(in srgb, var(--warn-fill) 14%, transparent)', border: '1px solid color-mix(in srgb, var(--warn-fill) 40%, transparent)', borderRadius: 10, padding: '11px 14px', color: 'var(--warn)', fontSize: 13, fontWeight: 500 }}
            >
              ⚠️ {cw.xlkn} khiếu nại (XLKN) cần xử lý trong tuần
            </div>
          )}
          {canReport && (
            <button
              className="btn"
              style={{ marginTop: 16 }}
              onClick={() => { const ks = [...cwKeys].sort(); setWeekReport({ from: ks[0], to: ks[ks.length - 1], label: `Tuần (${cwLabel})` }); }}
            >
              📝 Báo cáo tuần
            </button>
          )}
        </div>
      </div>
      )}

      {/* Chi tiết theo ngày */}
      {!loading && logs.length > 0 && (
        <div className="card" style={{ marginTop: 16 }}>
          <div className="row between" style={{ marginBottom: 12, flexWrap: 'wrap', gap: 10, alignItems: 'center' }}>
            <h3 style={{ margin: 0 }}>Chi tiết <span className="small muted" style={{ fontWeight: 400 }}>({detailLogs.length} việc)</span></h3>
            <div className="row" style={{ gap: 8, flexWrap: 'wrap' }}>
              <button
                className={'btn sm' + (onlyPending ? '' : ' ghost')}
                style={onlyPending ? { background: 'var(--danger)', borderColor: 'var(--danger)', color: '#fff' } : {}}
                onClick={() => setOnlyPending((v) => !v)}
                title="Chỉ hiện việc XLKN / KH không hài lòng mà CSKH CHƯA ấn Hoàn thành"
              >
                ⏳ Chưa xử lí xong{pendingCount ? ` (${pendingCount})` : ''}
              </button>
              <select value={fType} onChange={(e) => setFType(e.target.value)} style={{ width: 'auto' }} title="Lọc theo loại công việc">
                <option value="all">Tất cả loại</option>
                <option value="cskh">CSKH</option>
                <option value="xlkn">XLKN (khiếu nại)</option>
              </select>
              <select value={fResult} onChange={(e) => setFResult(e.target.value)} style={{ width: 'auto' }} title="Lọc theo kết quả">
                <option value="all">Tất cả kết quả</option>
                {Object.entries(RESULTS).map(([k, v]) => (
                  <option key={k} value={k}>{v.label}</option>
                ))}
              </select>
              {(fType !== 'all' || fResult !== 'all' || onlyPending) && (
                <button className="btn sm ghost" onClick={() => { setFType('all'); setFResult('all'); setOnlyPending(false); }}>Xoá lọc</button>
              )}
            </div>
          </div>
          {detailLogs.length === 0 && (
            <div className="small muted" style={{ padding: '12px 0' }}>Không có việc nào khớp bộ lọc.</div>
          )}
          {Object.entries(byDay).map(([day, items]) => (
            <div key={day} style={{ marginBottom: 18 }}>
              <div className="small muted" style={{ fontWeight: 700, marginBottom: 6 }}>📅 {day} · {items.length} việc</div>
              <div className="tbl-wrap">
              <table className="cskh-detail-tbl" style={{ fontSize: 13, minWidth: 760 }}>
                <thead>
                  <tr>
                    <th style={{ width: 180 }}>Khách hàng</th>
                    <th style={{ width: 130 }}>Sale</th>
                    <th style={{ width: 70 }}>Loại</th>
                    {/* Cột 'Nhân viên' tạm ẩn — hiện chỉ có 1 CSKH nên không cần. */}
                    <th>Nội dung</th>
                    <th style={{ width: 150 }}>Kết quả</th>
                    {canLog && <th style={{ width: 210 }}></th>}
                    <th style={{ width: 50 }}></th>
                  </tr>
                </thead>
                <tbody>
                  {items.map((l) => {
                    const cCode = l.custCode || (l.customer || '').split('·')[0].trim();
                    const cName = l.custName || (l.customer || '').split('·').slice(1).join('·').trim();
                    return (
                    <tr key={l._id}>
                      <td>
                        {cCode ? <code style={{ color: 'var(--warn)', fontSize: 12.5 }}>{cCode}</code> : <span className="small muted">—</span>}
                        <div style={{ fontWeight: 600, marginTop: 2 }}>{cName || <span className="small muted">—</span>}</div>
                      </td>
                      <td>{l.custSale ? l.custSale : <span className="small muted">—</span>}</td>
                      <td>
                        <span className={'tag ' + (l.type === 'xlkn' ? 'warn' : '')}>{l.type === 'xlkn' ? 'XLKN' : 'CSKH'}</span>
                      </td>
                      {/* Cột 'Nhân viên' tạm ẩn — hiện chỉ có 1 CSKH nên không cần. */}
                      <td style={{ maxWidth: 360, wordBreak: 'break-word', whiteSpace: 'pre-wrap' }}>
                        {l.content}
                        {(l.updates || []).map((u, i) => (
                          <div key={i} className="small" style={{ marginTop: 4, paddingLeft: 8, borderLeft: '2px solid var(--border)', color: 'var(--muted)' }}>
                            <b style={{ color: 'var(--accent2)' }}>↳ {u.byName || 'CSKH'}</b> <span className="muted">({fmtDate(u.at)}):</span> {u.text}
                          </div>
                        ))}
                      </td>
                      <td>
                        {l.result && RESULTS[l.result] ? (
                          <span style={{ color: RESULTS[l.result].color, fontWeight: 700, whiteSpace: 'nowrap' }}>● {RESULTS[l.result].label}</span>
                        ) : (
                          <span className="small muted">—</span>
                        )}
                        {l.resolvedAt && (
                          <div className="small" style={{ color: '#0d9488', fontWeight: 700, marginTop: 3, whiteSpace: 'nowrap' }} title={l.resolvedBy ? `Xử lí xong bởi ${l.resolvedBy}` : ''}>
                            ✓ Đã xử lí xong{l.resolvedBy ? ` · ${l.resolvedBy}` : ''}
                          </div>
                        )}
                      </td>
                      {canLog && (
                        <td>
                          <div className="row" style={{ gap: 4, flexWrap: 'wrap' }}>
                            <button
                              className="btn sm"
                              disabled={!cCode}
                              title={cCode ? 'Tạo công việc cho nhóm KD của KH này' : 'Chưa gắn mã KH'}
                              onClick={() => openTaskFor(cCode, cName)}
                            >
                              ＋ Tạo công việc
                            </button>
                            <button className="btn sm ghost" title="Bổ sung nội dung / cập nhật tình trạng" onClick={() => doAddUpdate(l)}>
                              ✎ Cập nhật
                            </button>
                            {/* XLKN / KH không hài lòng: nút xác nhận đã xử lí xong */}
                            {(l.type === 'xlkn' || l.result === 'unhappy') && (
                              l.resolvedAt ? (
                                <button className="btn sm ghost" title="Bỏ đánh dấu hoàn thành" onClick={() => doResolve(l, false)}>↩ Bỏ hoàn thành</button>
                              ) : (
                                <button className="btn sm" style={{ background: '#0d9488', borderColor: '#0d9488', color: '#fff' }} title="Xác nhận đã xử lí xong" onClick={() => doResolve(l, true)}>
                                  ✓ Hoàn thành
                                </button>
                              )
                            )}
                          </div>
                        </td>
                      )}
                      <td>
                        {(String(l.user?._id) === myId || isAdmin) && (
                          <button className="btn sm ghost" onClick={() => del(l._id)}>Xóa</button>
                        )}
                      </td>
                    </tr>
                    );
                  })}
                </tbody>
              </table>
              </div>
            </div>
          ))}
        </div>
      )}

      <Modal open={!!detail} onClose={() => setDetail(null)} wide>
        <h3 style={{ marginTop: 0 }}>{detail?.title} — {detailRows.length} KH</h3>
        <div className="tbl-wrap">
          <table style={{ fontSize: 13, minWidth: 760 }}>
            <thead>
              <tr>
                <th style={{ width: 90 }}>Mã KH</th>
                <th>Tên KH</th>
                <th style={{ width: 130 }}>Sale</th>
                <th style={{ width: 80 }}>Loại</th>
                <th>Nội dung</th>
                <th style={{ width: 150 }}>Kết quả</th>
              </tr>
            </thead>
            <tbody>
              {detailRows.length ? (
                detailRows.map((l) => (
                  <tr key={l._id}>
                    <td><code style={{ color: 'var(--warn)' }}>{l.custCode || '—'}</code></td>
                    <td>{l.custName || l.customer || <span className="small muted">—</span>}</td>
                    <td>{l.custSale || <span className="small muted">—</span>}</td>
                    <td><span className={'tag ' + (l.type === 'xlkn' ? 'warn' : '')}>{l.type === 'xlkn' ? 'XLKN' : 'CSKH'}</span></td>
                    <td style={{ whiteSpace: 'pre-wrap' }}>{l.content}</td>
                    <td>
                      {l.result && RESULTS[l.result] ? (
                        <span style={{ color: RESULTS[l.result].color, fontWeight: 700 }}>● {RESULTS[l.result].label}</span>
                      ) : (
                        <span className="small muted">—</span>
                      )}
                    </td>
                  </tr>
                ))
              ) : (
                <tr><td colSpan={6} className="empty">Không có dữ liệu.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </Modal>

      {weekReport && <WeekReportModal range={weekReport} onClose={() => setWeekReport(null)} toast={toast} />}
    </>
  );
}

// Các mục "cần theo dõi tiếp" hiển thị dạng bảng (nội dung cũ + note TP + chốt nội dung).
const FOLLOW_SECTIONS = [
  { key: 'noanswer', label: 'KH không nghe máy', dot: 'var(--warn-fill, #e0a400)' },
  { key: 'unhappy', label: 'KH không hài lòng', dot: 'var(--danger)' },
  { key: 'stopped', label: 'KH dừng giảm', dot: '#9333ea' },
  { key: 'xlkn', label: 'Xử lý khiếu nại (XLKN)', dot: 'var(--info)' },
];

// Soạn & nộp báo cáo tuần CSKH (chốt nội dung + nhận xét tuần trước khi nộp).
function WeekReportModal({ range, onClose, toast }) {
  const { me } = useAuth();
  const [data, setData] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    getCskhWeekReport(range.from, range.to)
      .then((d) =>
        setData({
          from: range.from,
          to: range.to,
          label: range.label,
          saved: d.saved,
          totalContacted: d.totalContacted || 0,
          happy: d.happy || [],
          noanswer: d.noanswer || [],
          unhappy: d.unhappy || [],
          stopped: d.stopped || [],
          xlkn: d.xlkn || [],
          weekNote: d.weekNote || '',
        })
      )
      .catch((e) => toast(e.response?.data?.message || 'Lỗi tải báo cáo', 'danger'));
  }, [range.from, range.to]);

  const setChot = (sec, i, val) =>
    setData((p) => ({ ...p, [sec]: p[sec].map((it, j) => (j === i ? { ...it, chot: val } : it)) }));

  async function submit() {
    setSaving(true);
    try {
      await saveCskhWeekReport(data);
      toast('Đã nộp báo cáo tuần');
      onClose();
    } catch (e) {
      toast(e.response?.data?.message || 'Lỗi nộp báo cáo', 'danger');
    } finally {
      setSaving(false);
    }
  }

  const total = data?.totalContacted || 0;
  const happyN = data?.happy?.length || 0;

  return (
    <Modal open onClose={onClose} wide>
      <div className="row between" style={{ alignItems: 'flex-start', gap: 12, marginBottom: 22 }}>
        <div>
          <h3 style={{ margin: 0, fontSize: 20 }}>Báo cáo CSKH — {range.label}</h3>
          <div className="mono small muted" style={{ marginTop: 4 }}>
            {fmtDate(range.from)} → {fmtDate(range.to)}{me?.name ? ` · ${me.name}` : ''}
          </div>
        </div>
        <div className="row" style={{ gap: 10, flex: '0 0 auto' }}>
          <button className="btn ghost" onClick={onClose}>Hủy</button>
          <button className="btn" disabled={saving || !data} onClick={submit}>{saving ? 'Đang nộp…' : 'Nộp báo cáo'}</button>
        </div>
      </div>
      {!data ? (
        <div className="empty">Đang tải…</div>
      ) : (
        <>
          {data.saved && <div className="small" style={{ color: 'var(--accent)', marginBottom: 14 }}>Đã nộp trước đó — sửa lại & nộp để cập nhật.</div>}

          {/* 2 thẻ tổng quan */}
          <div className="row" style={{ gap: 16, marginBottom: 26, flexWrap: 'wrap' }}>
            <div style={{ background: 'var(--input)', border: '1px solid var(--border)', borderRadius: 14, padding: '16px 22px', display: 'flex', alignItems: 'center', gap: 16 }}>
              <div>
                <div className="small muted" style={{ fontWeight: 500 }}>Tổng KH đã liên hệ</div>
                <div className="mono" style={{ fontSize: 30, fontWeight: 600, lineHeight: 1.1, marginTop: 2 }}>{total}</div>
              </div>
              <div className="small muted" style={{ maxWidth: 96, lineHeight: 1.4 }}>Tự động tính theo báo cáo</div>
            </div>
            <div style={{ background: '#e7f6ef', border: '1px solid #c9ead9', borderRadius: 14, padding: '16px 26px', display: 'flex', alignItems: 'center', gap: 14 }}>
              <span style={{ width: 10, height: 10, borderRadius: '50%', background: 'var(--ok)' }} />
              <span style={{ fontSize: 15, fontWeight: 600, color: '#0f7a55' }}>KH hài lòng</span>
              <span className="mono" style={{ fontSize: 30, fontWeight: 600, lineHeight: 1, color: '#0f7a55' }}>{happyN}</span>
            </div>
          </div>

          {/* 3 nhóm cần theo dõi */}
          {FOLLOW_SECTIONS.map((s) => (
            <div key={s.key} style={{ marginBottom: 28 }}>
              <div className="row" style={{ gap: 10, alignItems: 'center', marginBottom: 12 }}>
                <span style={{ width: 11, height: 11, borderRadius: '50%', background: s.dot, flex: '0 0 auto' }} />
                <span style={{ fontSize: 16, fontWeight: 700 }}>{s.label}</span>
                <span className="mono small muted">({data[s.key].length})</span>
              </div>
              {data[s.key].length ? (
                <div style={{ background: 'var(--panel)', border: '1px solid var(--border)', borderRadius: 12, overflow: 'hidden' }}>
                  <div style={{ display: 'grid', gridTemplateColumns: '170px minmax(170px,1fr) minmax(170px,1fr) minmax(170px,1fr) minmax(210px,1.2fr)', gap: 20, padding: '11px 20px', borderBottom: '1px solid var(--line)', fontSize: 11, fontWeight: 600, letterSpacing: '.05em', textTransform: 'uppercase', color: 'var(--muted2)' }}>
                    <div>Mã / Tên KH</div><div>Nội dung cũ</div><div>Giải trình nhân viên</div><div>Note trưởng nhóm</div><div>Chốt nội dung</div>
                  </div>
                  {data[s.key].map((it, i) => (
                    <div key={i} style={{ display: 'grid', gridTemplateColumns: '170px minmax(170px,1fr) minmax(170px,1fr) minmax(170px,1fr) minmax(210px,1.2fr)', gap: 20, padding: '15px 20px', borderBottom: '1px solid var(--line)', alignItems: 'start' }}>
                      <div>
                        <div className="mono" style={{ fontSize: 13, fontWeight: 600, color: '#a06a1a' }}>{it.custCode || '—'}</div>
                        <div style={{ fontSize: 13.5, fontWeight: 600, marginTop: 2 }}>{it.custName || '—'}</div>
                      </div>
                      <div style={{ fontSize: 13.5, color: 'var(--text2)', lineHeight: 1.45 }}>{it.content || <span style={{ color: 'var(--faint)' }}>—</span>}</div>
                      <div style={{ fontSize: 13.5, color: 'var(--ok)', lineHeight: 1.45 }}>
                        {it.staffNote ? it.staffNote : <span style={{ color: 'var(--faint)' }}>⏳ chờ NV phản hồi</span>}
                      </div>
                      <div style={{ fontSize: 13.5, color: 'var(--accent)', lineHeight: 1.45 }}>
                        {it.leaderNote ? it.leaderNote : <span style={{ color: 'var(--faint)' }}>⏳ chờ TP phản hồi</span>}
                      </div>
                      <div>
                        <textarea
                          rows={2}
                          style={{ width: '100%', minHeight: 64, background: 'var(--panel)', border: '1px solid var(--border)', borderRadius: 9, padding: '11px 13px', fontSize: 13.5, fontFamily: 'inherit' }}
                          placeholder="Ghi kết luận…"
                          value={it.chot || ''}
                          onChange={(e) => setChot(s.key, i, e.target.value)}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="small muted" style={{ padding: '2px 12px' }}>Không có.</div>
              )}
            </div>
          ))}

          {/* Nhận xét chung tuần */}
          <div style={{ marginTop: 8 }}>
            <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 12 }}>
              Nhận xét chung của CSKH trong tuần <span className="small muted" style={{ fontWeight: 400 }}>(nếu có)</span>
            </div>
            <textarea
              rows={4}
              style={{ width: '100%', minHeight: 120, background: 'var(--panel)', border: '1px solid var(--border)', borderRadius: 12, padding: '14px 16px', fontSize: 13.5, fontFamily: 'inherit' }}
              placeholder="Tình hình chung, vấn đề nổi bật, đề xuất…"
              value={data.weekNote}
              onChange={(e) => setData((p) => ({ ...p, weekNote: e.target.value }))}
            />
          </div>

          <div className="row" style={{ marginTop: 20, justifyContent: 'flex-end', gap: 10 }}>
            <button className="btn ghost" onClick={onClose}>Hủy</button>
            <button className="btn" disabled={saving} onClick={submit}>{saving ? 'Đang nộp…' : 'Nộp báo cáo'}</button>
          </div>
        </>
      )}
    </Modal>
  );
}

// Ô nhập BỔ SUNG NỘI DUNG (cập nhật tình trạng) cho 1 việc CSKH đã ghi.
function UpdateStatusModal({ log, onCancel, onSubmit }) {
  const [text, setText] = useState('');
  const [busy, setBusy] = useState(false);
  async function submit() {
    if (busy || !text.trim()) return;
    setBusy(true);
    try { await onSubmit(text.trim()); } finally { setBusy(false); }
  }
  return (
    <>
      <span className="close" onClick={onCancel}>×</span>
      <h3 style={{ marginTop: 0 }}>Cập nhật tình trạng</h3>
      <div className="small muted" style={{ marginBottom: 4 }}>Việc gốc:</div>
      <div className="small" style={{ marginBottom: 10, padding: '8px 10px', background: 'var(--panel2)', borderRadius: 8, wordBreak: 'break-word' }}>
        {(log.custCode || log.custName) && <b>{[log.custCode, log.custName].filter(Boolean).join(' · ')}: </b>}{log.content}
      </div>
      {(log.updates || []).length > 0 && (
        <div style={{ marginBottom: 10 }}>
          {log.updates.map((u, i) => (
            <div key={i} className="small" style={{ paddingLeft: 8, borderLeft: '2px solid var(--border)', color: 'var(--muted)', marginBottom: 4 }}>
              <b style={{ color: 'var(--accent2)' }}>↳ {u.byName || 'CSKH'}</b> ({fmtDate(u.at)}): {u.text}
            </div>
          ))}
        </div>
      )}
      <div className="field">
        <label>Nội dung bổ sung</label>
        <textarea rows={4} value={text} onChange={(e) => setText(e.target.value)} placeholder="vd: Đã gọi lại, KH đồng ý tiếp tục dùng dịch vụ…" autoFocus />
      </div>
      <div className="row" style={{ justifyContent: 'flex-end', gap: 8, marginTop: 8 }}>
        <button className="btn ghost" onClick={onCancel}>Hủy</button>
        <button className="btn" disabled={busy || !text.trim()} onClick={submit}>{busy ? 'Đang lưu…' : 'Lưu cập nhật'}</button>
      </div>
    </>
  );
}
